export const messages = {
  en: {
    miscFeeCreate: {
      title: 'Misc Fee Billing',
      searchTitle: 'Room Search',
      searchType: 'Search Type',
      roomNum: 'Room No.',
      ownerName: 'Owner Name',
      keywordPlaceholder: 'Enter room number or owner name',
      query: 'Query',
      reset: 'Reset',
      roomList: 'Room List',
      roomName: 'Room',
      owner: 'Owner',
      floor: 'Floor',
      unit: 'Unit',
      area: 'Area',
      operation: 'Operation',
      choose: 'Choose',
      billingTitle: 'Billing Info',
      selectedRoom: 'Selected Room',
      selectedOwner: 'Selected Owner',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      remark: 'Remark',
      submit: 'Submit',
      configTip: 'Only the four misc fee types are shown. Configure fee items first if no items appear.',
      noRoomSelected: 'Please select a room first',
      keywordRequired: 'Please enter search keyword',
      feeTypeRequired: 'Please select fee type',
      feeItemRequired: 'Please select fee item',
      amountRequired: 'Please enter amount',
      startTimeRequired: 'Please select start time',
      endTimeRequired: 'Please select end time',
      endTimeMustAfterStart: 'End time must be after start time',
      storeRequired: 'Store ID was not found',
      noRoomFound: 'No rooms found',
      saveSuccess: 'Created successfully',
      advertisementFee: 'Advertisement Fee',
      decorationDeposit: 'Decoration Deposit',
      temporaryServiceFee: 'Temporary Service Fee',
      venueMiscellaneousFee: 'Venue Miscellaneous Fee'
    }
  },
  zh: {
    miscFeeCreate: {
      title: '杂项费开单',
      searchTitle: '房屋查询',
      searchType: '查询方式',
      roomNum: '房号',
      ownerName: '业主姓名',
      keywordPlaceholder: '请输入房号或业主姓名',
      query: '查询',
      reset: '重置',
      roomList: '房屋列表',
      roomName: '房屋',
      owner: '业主',
      floor: '楼栋',
      unit: '单元',
      area: '面积',
      operation: '操作',
      choose: '选择',
      billingTitle: '开单信息',
      selectedRoom: '已选房屋',
      selectedOwner: '已选业主',
      feeType: '费用类型',
      feeItem: '费用项',
      amount: '金额',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      remark: '备注',
      submit: '提交开单',
      configTip: '此页面仅展示四类杂项费；若费用项为空，请先到费用项设置中配置对应费用项。',
      noRoomSelected: '请先选择房屋',
      keywordRequired: '请输入查询关键字',
      feeTypeRequired: '请选择费用类型',
      feeItemRequired: '请选择费用项',
      amountRequired: '请输入金额',
      startTimeRequired: '请选择计费起始时间',
      endTimeRequired: '请选择计费结束时间',
      endTimeMustAfterStart: '计费结束时间必须大于计费起始时间',
      storeRequired: '未获取到商户ID',
      noRoomFound: '未查询到房屋',
      saveSuccess: '开单成功',
      advertisementFee: '广告费',
      decorationDeposit: '装修押金',
      temporaryServiceFee: '临时服务费',
      venueMiscellaneousFee: '场地杂费'
    }
  },
  'zh-TW': {
    miscFeeCreate: {
      title: '雜項費開單',
      searchTitle: '房屋查詢',
      searchType: '查詢方式',
      roomNum: '房號',
      ownerName: '業主姓名',
      keywordPlaceholder: '請輸入房號或業主姓名',
      query: '查詢',
      reset: '重置',
      roomList: '房屋列表',
      roomName: '房屋',
      owner: '業主',
      floor: '樓棟',
      unit: '單元',
      area: '面積',
      operation: '操作',
      choose: '選擇',
      billingTitle: '開單資訊',
      selectedRoom: '已選房屋',
      selectedOwner: '已選業主',
      feeType: '費用類型',
      feeItem: '費用項',
      amount: '金額',
      startTime: '計費起始時間',
      endTime: '計費結束時間',
      remark: '備註',
      submit: '提交開單',
      configTip: '此頁面僅展示四類雜項費；若費用項為空，請先到費用項設置中配置對應費用項。',
      noRoomSelected: '請先選擇房屋',
      keywordRequired: '請輸入查詢關鍵字',
      feeTypeRequired: '請選擇費用類型',
      feeItemRequired: '請選擇費用項',
      amountRequired: '請輸入金額',
      startTimeRequired: '請選擇計費起始時間',
      endTimeRequired: '請選擇計費結束時間',
      endTimeMustAfterStart: '計費結束時間必須大於計費起始時間',
      storeRequired: '未獲取到商戶ID',
      noRoomFound: '未查詢到房屋',
      saveSuccess: '開單成功',
      advertisementFee: '廣告費',
      decorationDeposit: '裝修押金',
      temporaryServiceFee: '臨時服務費',
      venueMiscellaneousFee: '場地雜費'
    }
  }
}
